const ValidationTypes = {
  EMAIL: 'email',
  PASSWORD: 'password',
  CUSTOM: 'custom',
  PHONE: 'phone',
  IMAGE: 'image',
  ATTACHMENT: 'attachment',
};

export default ValidationTypes;
